<div id="get-pro-dialog">
  <button (click)="onDismiss()" mat-icon-button id="modal-close">
    <mat-icon>close</mat-icon>
  </button>
  @if (isLoading) {
    <div class="loading">
      <mat-spinner [diameter]="40" />
    </div>
  } @else {
    @if (!hasActiveOrder) {
      <div id="pro-upgrade-content">
        <div class="image">
          <div class="image-text">{{ config.imageText | translate }}</div>
          <img [src]="config.imageUrl" height="auto" width="365" />
        </div>
        <div class="dialog-content">
          <div class="upgrade">
            <mat-chip-listbox class="chips">
              @if (config.editionName) {
                <mat-chip-option class="chip">
                  {{ config.editionName | translate }}
                </mat-chip-option>
              }
            </mat-chip-listbox>
            @if (config.price !== null) {
              <div>
                {{ config.upgradeNowText | translate }}
              </div>
            }
          </div>
          @if (config.price !== null) {
            <div class="price">
              <span class="amount" [ngClass]="{ small: config.price && config.price.length > 10 }">
                {{ config.price }}
              </span>
              <span
                class="frequency"
              [ngClass]="{
                'small-price': config.price && config.price.length > 10,
              }"
                >
                {{ config.frequency | translate }}
              </span>
            </div>
          }
          <div class="selling-points">
            @for (sellingPoint of sanitizedSellingPoints; track sellingPoint) {
              <div class="selling-point">
                <mat-icon>check_circle_outline</mat-icon>
                <div [innerHtml]="sellingPoint | translate"></div>
              </div>
            }
            @for (sellingPoint of config.templateSellingPoints; track sellingPoint) {
              <div class="selling-point">
                @if (!(sellingPoint.template === undefined || sellingPoint.template === null)) {
                  <mat-icon>check_circle_outline</mat-icon>
                  {{ sellingPoint.text | translate: sellingPoint.template }}
                } @else {
                  <mat-icon>check_circle_outline</mat-icon>
                  {{ sellingPoint.text | translate }}
                }
              </div>
            }
          </div>
          @if (config.addons?.length) {
            <div class="addon-selector">
              @if (config.addonsLabel) {
                <div class="addon-selector__label">{{ config.addonsLabel | translate }}</div>
              }
              <mat-form-field appearance="outline" class="addon-selector__field">
                <mat-select
                  [(ngModel)]="selectedAddonId"
                  [placeholder]="(config.addonPlaceholder ? (config.addonPlaceholder | translate) : '')"
                >
                  @for (addon of config.addons; track addon.id) {
                    <mat-option [value]="addon.id">{{ addon.label | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          <button mat-raised-button class="upgrade-now-button" color="primary" (click)="onConfirm()">
            {{ config.ctaText | translate }}
          </button>
        </div>
      </div>
    } @else {
      <div class="active-order">
        @if (config.activeOrderImageUrl) {
          <img [src]="config.activeOrderImageUrl" class="active-order-image" />
        }
        <span class="active-order-primary">
          {{ config.activeOrderPrimaryText | translate }}
        </span>
        <span class="active-order-secondary">
          {{ config.activeOrderSecondaryText | translate }}
        </span>
      </div>
    }
  }
</div>
